#import "../fragments/contact-audience-memberships.graphql"
#import "../../../../contact/graphql/fragments/email-deliverability-fragment.graphql"
#import "../../../../contact/graphql/fragments/sms-deliverability-fragment.graphql"

mutation UnsubscribeContactFromAllAudiences(
    $contactId: ID!
    $shouldPrimaryEmailBeSubscribedToAllAudiences: Boolean
    $shouldPrimaryPhoneBeSubscribedToAllAudiences: Boolean
) {
    setIsContactSubscribedToAllAudiences(
        input: {
            contactId: $contactId
            shouldPrimaryEmailBeSubscribedToAllAudiences: $shouldPrimaryEmailBeSubscribedToAllAudiences
            shouldPrimaryPhoneBeSubscribedToAllAudiences: $shouldPrimaryPhoneBeSubscribedToAllAudiences
        }
    ) {
        contact {
            ...ContactAudienceMeberships
            hasUnsubscribedFromEmailAndSmsMarketing
            emailAddresses {
                primary {
                    id
                    deliverabilityStatus {
                        ...EmailDeliverabilityFragment
                    }
                }
                all {
                    id
                    deliverabilityStatus {
                        ...EmailDeliverabilityFragment
                    }
                }
            }
            phones {
                primary {
                    id
                    deliverabilityStatus {
                        ...SmsDeliverabilityFragment
                    }
                }
                all {
                    id
                    deliverabilityStatus {
                        ...SmsDeliverabilityFragment
                    }
                }
            }
        }
    }
}
